<template>
  <DataTable
    v-model:sortField="specialRequestFilter.pageable.sortField"
    v-model:sortOrder="specialRequestFilter.pageable.sortOrder"
    v-model:filters="specialRequestFilter.filters"
    v-model:rows="specialRequestFilter.pageable.size"
    striped-rows
    row-hover
    lazy
    paginator
    paginator-position="both"
    :value="specialRequests"
    :loading="isLoading"
    :rows="specialRequestFilter.pageable.size"
    :total-records="totalSpecialRequestsCount"
    @page="onPageChange($event)"
    @sort="onSort($event)"
    @filter="getSpecialRequests"
    responsive-layout="scroll"
    class="p-datatable-sm"
    filter-display="row"
  >
    <Column
      style="min-width:50px"
    >
      <template #body="{data}">
        <Button
          icon="pi pi-eye"
          class="p-button-rounded mx-1"
          :title="$t('action.details')"
          @click="toSpecialRequestForm(data.id)"
        />
      </template>
    </Column>
    <Column
      field="reasonRequest"
      :header="$t('entity.specialrequest.reasonRequest')"
      :sortable="true"
      :show-filter-menu="false"
      class="col-tab col-3"
    >
      <template #body="{ data }">
        {{ $t(EReasonRequest[data.reasonRequest]) }}
      </template>
      <template #filter="{ filterModel, filterCallback }">
        <InputText
          v-model="filterModel.value"
          type="text"
          class="p-column-filter"
          @keydown.enter="filterCallback()"
        />
      </template>
    </Column>
    <Column
      field="startingAvailabilityDatetime"
      :header="$t('specialRequestPage.startingAvailabilityDatetime')"
      :sortable="true"
      :show-filter-menu="false"
      class="col-tab col-2"
    >
      <template #body="{ data }">
        {{ formatDateTime(data.startingAvailabilityDatetime) }}
      </template>
      <template #filter="{ filterModel, filterCallback }">
        <Calendar
          v-model="filterModel.value"
          hour-format="24"
          class="p-column-filter"
          @date-select="filterCallback()"
        />
      </template>
    </Column>
    <Column
      field="endingAvailabilityDatetime"
      :header="$t('specialRequestPage.endingAvailabilityDatetime')"
      :sortable="true"
      :show-filter-menu="false"
      class="col-tab col-2"
    >
      <template #body="{ data }">
        {{ formatDateTime(data.endingAvailabilityDateTime) }}
      </template>
      <template #filter="{ filterModel, filterCallback }">
        <Calendar
          v-model="filterModel.value"
          hour-format="24"
          class="p-column-filter"
          @date-select="filterCallback()"
        />
      </template>
    </Column>
    <Column
      field="wishedMeetingAddress.city"
      :header="$t('specialRequestPage.city')"
      :sortable="true"
      :show-filter-menu="false"
      class="col-tab col-3"
    >
      <template #body="{ data }">
        {{ data.wishedMeetingAddress?.city }}
      </template>
      <template #filter="{ filterModel, filterCallback }">
        <InputText
          v-model="filterModel.value"
          type="text"
          class="p-column-filter"
          @keydown.enter="filterCallback()"
        />
      </template>
    </Column>
    <Column
      field="wishedMeetingAddress.postcode"
      :header="$t('specialRequestPage.postcode')"
      :sortable="true"
      :show-filter-menu="false"
      class="col-tab col-3"
    >
      <template #body="{ data }">
        {{ data.wishedMeetingAddress?.postcode }}
      </template>
      <template #filter="{ filterModel, filterCallback }">
        <InputText
          v-model="filterModel.value"
          type="text"
          class="p-column-filter"
          @keydown.enter="filterCallback()"
        />
      </template>
    </Column>
  </DataTable>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import {reactive} from "vue";
import useSpecialRequestFilter from "@/composables/filters/useSpecialRequestFilter";
import InputText from "primevue/inputtext";
import Calendar from "primevue/calendar";
import ESpecialRequestStatus from "@/models/enums/ESpecialRequestStatus";
import EReasonRequest from "@/models/enums/EReasonRequest";

export default {
  name: 'SpecialRequestTable',
  components: {DataTable, Column, Button, InputText, Calendar},
  setup(){
    const specialRequestFilter = reactive(useSpecialRequestFilter());
    specialRequestFilter.filters.status.value = ESpecialRequestStatus.PENDING;
    return {
      specialRequestFilter: specialRequestFilter,
    }
  },
  data() {
    return {
      /** @type {SpecialRequestDto[]}*/
      specialRequests: [],
      totalSpecialRequestsCount: 0,
      isLoading: false,
    }
  },
  computed: {
    EReasonRequest() {
      return EReasonRequest
    }
  },
  async mounted() {
    await this.getSpecialRequests();
  },
  methods: {
    async getSpecialRequests() {
      this.isLoading = true;
      try {
        const { content, totalElements } = await this.$specialRequestService.fetchAll(this.specialRequestFilter.getQueryParams());
        this.specialRequests = content;
        this.totalSpecialRequestsCount = totalElements;
      } catch (e) {
        console.error(e);
        this.$emitter.emit('toast', { severity: 'error', message: 'error.global' });
      } finally {
        this.isLoading = false;
      }
    },
    toSpecialRequestForm(specialRequestId) {
      if (specialRequestId) {
        this.$router.push({name: "specialRequestUpdateView", params: {id: specialRequestId}});
      }
    },
    onPageChange(event) {
      this.specialRequestFilter.pageable.page = event.page;
      this.getSpecialRequests();
    },
    onSort(event) {
      this.specialRequestFilter.pageable.sortField = event.sortField;
      this.specialRequestFilter.pageable.sortOrder = event.sortOrder;
      this.getSpecialRequests();
    },
    formatDateTime(date) {
      const dateStr = new Date(date).toLocaleString(this.$i18n.locale);
      return dateStr.substring(0, dateStr.length - 3);
    }
  }
}

</script>
